export default "__VITE_ASSET__CENkTf6u__"